import { render, staticRenderFns } from "./UpdatePwdForm.vue?vue&type=template&id=72a7c8a2&scoped=true"
import script from "./UpdatePwdForm.vue?vue&type=script&lang=js"
export * from "./UpdatePwdForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a7c8a2",
  null
  
)

export default component.exports